import dayjs from 'dayjs';
import { setSelectOne } from 'feature/tableSelectedItems/tableSelectedItemsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import { Checkbox, TableBody, TableCell, TableRow, Typography } from 'styles';
import { IMemberBilling } from 'types/Billing';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';
import { formatPrice, getShortDate } from 'utils/utils';

interface IMembersBillingTableBody {
	membersBilling: IMemberBilling[];
}

const MembersBillingTableBody = ({
	membersBilling,
}: IMembersBillingTableBody) => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const { t: tDbLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.DB_LABELS,
	});
	const { selectedItems, downloadAll } = useSelector(
		(store: RootState) => store.tableSelectedItems,
	);
	const dispatch = useDispatch<AppDispatch>();
	const { networks } = useSelector((store: RootState) => store.form);

	return membersBilling.length > 0 ? (
		<TableBody>
			{membersBilling.map((el, idx) => (
				<TableRow
					key={idx}
					sx={{
						'& > td': {

							padding: '5px 0px 5px 10px',
							'&:last-of-type': { minWidth: 'auto' },
							'&:first-of-type': { minWidth: 'auto' },
						},
					}}
				>
					<TableCell>
						<Checkbox
							label=""
							sx={{ p: 0, ml: 0 }}
							checked={
								downloadAll
									? !selectedItems.find(id => el.externalMemberId === id)
									: !!selectedItems.find(id => el.externalMemberId === id)
							}
							onClick={() => dispatch(setSelectOne(el.externalMemberId))}
						/>
					</TableCell>
					<TableCell>
						<Typography variant="body">{el.carrierName || '-'}</Typography>
					</TableCell>
					<TableCell>
						<Typography variant="body">
							{tDbLabels(el.billingType?.label) || '-'}
						</Typography>
					</TableCell>
					<TableCell>
						<Typography variant="body">
							{formatPrice(el.rateAmount) ?? '-'}
						</Typography>
					</TableCell>
					<TableCell>
						<Typography variant="body">{el.billingId || '-'}</Typography>
					</TableCell>
					<TableCell>
						<Typography variant="body">
							{tDbLabels(el.adminBillingStatus?.label || '') || '-'}
						</Typography>
					</TableCell>
					<TableCell>
						<Typography variant="body">
							{el.billingMonth
								? dayjs(el.billingMonth, 'YYYY-MM').format('MMM YYYY')
								: '-'}
						</Typography>
					</TableCell>
					<TableCell>
						<Typography variant="body">{el.clientName || '-'}</Typography>
					</TableCell>
					<TableCell>
						<Typography variant="body">{el.groupName || '-'}</Typography>
					</TableCell>
					<TableCell>
						<Typography variant="body">{el.planName || '-'}</Typography>
					</TableCell>
					<TableCell>
						<Typography variant="body">{el.divisionCode || '-'}</Typography>
					</TableCell>
					<TableCell>
						<Typography variant="body">{el.memberSurname || '-'}</Typography>
					</TableCell>
					<TableCell>
						<Typography variant="body">{el.memberName || '-'}</Typography>
					</TableCell>
					<TableCell>
						<Typography variant="body">{el.relationshipCode || '-'}</Typography>
					</TableCell>
					<TableCell>
						<Typography variant="body">{el.externalMemberId || '-'}</Typography>
					</TableCell>
					<TableCell>
						<Typography variant="body">{el.memberEyemedId || '-'}</Typography>
					</TableCell>
					<TableCell>
						<Typography variant="body">
							{getShortDate(el.subscriptionStart) || '-'}
						</Typography>
					</TableCell>
					<TableCell>
						<Typography variant="body">
							{getShortDate(el.subscriptionEnd) || '-'}
						</Typography>
					</TableCell>
					<TableCell>
						<Typography variant="body">
							{networks.find(network => network.networkCode === el.networkCode)
								?.name || '-'}
						</Typography>
					</TableCell>
					<TableCell />
					<TableCell />
				</TableRow>
			))}
		</TableBody>
	) : (
		<TableBody
			sx={{
				'& td': {
					paddingLeft: '0px!important',
					textAlign: 'left!important',
					backgroundColor: 'transparent!important',
				},
			}}
		>
			<TableRow>
				<TableCell colSpan={20}>
					<Typography variant="bodyLink" sx={{ width: '100%' }}>
						{tClientLabels('commons.noResultsFound')}
					</Typography>
				</TableCell>
			</TableRow>
		</TableBody>
	);
};

export default MembersBillingTableBody;
